import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import { HttpStatusCodes, AssignmentStatusIds, unassignedId, TaskStatusIds } from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function assignmentReducer(state = initialState.assignments, action) {
	switch (action.type) {
		case types.GET_ASSIGNMENTS: {
			return action.response;
		}
		case types.CREATE_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Created) {
				// add response object into state
				let newState = _.cloneDeep(state);

				// set isNew as false
				newState.forEach((item) => {
					item.isNew = false;
				});

				// set new item as new
				let item = action.response;
				item.isNew = true;

				newState.push(item);

				// sort
				newState.sort((a, b) => {
					return a.assignmentTypeId - b.assignmentTypeId !== 0
						? a.assignmentTypeId - b.assignmentTypeId
						: b.name - a.name;
				});

				return newState;
			} else {
				return state;
			}
		}
		case types.CLEAN_ASSIGNMENTS: {
			return [];
		}
		case types.RESET_FLAG_ASSIGNMENTS: {
			let resetedFlag = _.cloneDeep(state);

			// set isNew as false
			resetedFlag.forEach((item) => {
				item.isNew = false;
			});

			return resetedFlag;
		}
		case types.GET_USER_ASSIGNMENTS: {
			return action.response;
		}
		default:
			return state;
	}
}

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function manageAssignmentReducer(state = initialState.manageAssignments, action) {
	switch (action.type) {
		case types.GET_MANAGE_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return [];
		}
		case types.GET_MANAGE_ASSIGNMENTS_TASKS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				// add response object into assignment item
				let newState = _.cloneDeep(state);

				// look for assignmnet
				let assignment = newState.find((x) => x.id === action.assignmentId);

				if (assignment) {
					// look for user/role
					let member = assignment.assignmentSumary?.find(
						(x) => x.assignedToUserId === action.assignedTo || x.assignedToRoleId === action.assignedTo
					);

					// add tasks in assignment/member property
					if (member) {
						// create task list
						let tasks = {
							totalCount: 0,
							availablePages: 0,
							items: []
						};

						// get assignment response
						let responseTasks = action.response?.find((x) => x.id === action.assignmentId);

						if (responseTasks) {
							let totalCount = 0;
							let availablePages = 0;

							// validate summary response
							let summary = responseTasks.assignmentSumary?.find(
								(x) => x.assignedToUserId === action.assignedTo || x.assignedToRoleId === action.assignedTo
							);

							if (summary) {
								// create pagination result
								totalCount = summary.countAssignments;
								availablePages = Math.ceil(totalCount / action.pageSize);

								// reload status count
								member.countAssignmentStatusOpen = summary.countAssignmentStatusOpen;
								member.countAssignmentStatusInProcess = summary.countAssignmentStatusInProcess;
								member.countAssignmentStatusComplete = summary.countAssignmentStatusComplete;
								member.countTasks = totalCount;
							}

							// list of tasks
							let taskList = responseTasks.taskAssignments;

							tasks = {items: [...taskList], availablePages, totalCount};
						}

						member.tasks = tasks;
					}
				}

				return newState;
			} else {
				return state;
			}
		}
		case types.EDIT_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.NoContent) {
				// Add response object into state
				let newState = _.cloneDeep(state);
				// Get modified the assignment by id.
				let editedAssignment = newState.find((x) => x.id === action.assignment.assignmentId);
				if (editedAssignment) {
					if (editedAssignment.assignmentTypeId !== action.assignment.assignmentType) {
						// If is changed the assigntype, I remove it from the state to don't show it on the list.
						newState = newState.filter((x) => x.id !== action.assignment.assignmentId);
					} else {
						editedAssignment.name = action.assignment.assignmentName;
					}
				}
				return newState;
			}
			return state;
		}

		case types.CREATE_ASSIGNMENTS_TO_LIST: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Created) {
				// add response object into state
				let newState = _.cloneDeep(state);

				// set isNew as false
				newState.forEach((item) => {
					item.isNew = false;
				});

				// set new item as new
				let item = action.response;
				item.isNew = true;

				newState.push(item);

				// sort
				// newState.sort((a, b) => {
				// 	return a.assignmentTypeId - b.assignmentTypeId !== 0
				// 		? a.assignmentTypeId - b.assignmentTypeId
				// 		: b.name - a.name;
				// });
				return newState;
			} else {
				return state;
			}
		}
		case types.DELETE_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.NoContent) {
				// Add response object into state
				let newState = _.cloneDeep(state);
				// Remove deleted assignment from the list
				newState = newState.filter((x) => x.id !== action.assignmentId);
				return newState;
			}
			return state;
		}
		case types.CLEAN_MANAGE_ASSIGNMENTS: {
			return [];
		}
		
		case types.DELETE_TASK_ASSIGNMENT: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.NoContent) {
				// get data
				let newState = _.cloneDeep(state);
				let assignmentInfo = action.assignment;

				// find assignment
				let assignment = newState.find((x) => x.id === assignmentInfo?.assignmentId);
				if (assignment) {
					// find member, then reduce status count
					let member = assignment.assignmentSumary.find(
						(x) => x.assignedToUserId === assignmentInfo.memberId || x.assignedToRoleId === assignmentInfo.memberId
					);

					if (member) {
						// find task to know the status
						let task = member.tasks?.items.find((x) => x.taskId === assignmentInfo.taskId);
						if (task) {
							let statusId = task.assignmentStatusId;

							// remove task from items
							member.tasks.items = member.tasks.items.filter((x) => x.taskId !== assignmentInfo.taskId);

							// discount status
							switch (statusId) {
								case AssignmentStatusIds.Open:
									if (member.countAssignmentStatusOpen !== 0) {
										member.countAssignmentStatusOpen--;
									}
									break;
								case AssignmentStatusIds.InProgress:
									if (member.countAssignmentStatusInProcess !== 0) {
										member.countAssignmentStatusInProcess--;
									}
									break;
								case AssignmentStatusIds.Closed:
									if (member.countAssignmentStatusComplete !== 0) {
										member.countAssignmentStatusComplete--;
									}
									break;
								default:
									break;
							}

							// discount total task
							member.countTasks--;
						}
					}
				}

				return newState;
			}

			return state;
		}
		case types.DELETE_USER_TASK_ASSIGNMENT: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.NoContent) {
				// get data
				let newState = _.cloneDeep(state);
				let assignmentInfo = action.assignment;

				// find assignment
				let assignment = newState.find((x) => x.id === assignmentInfo.assignmentId);
				if (assignment) {
					// remove user/role from list
					let filterSumary = assignment.assignmentSumary.filter((x) => {
						if (isNaN(assignmentInfo.memberId)) {
							// filter user
							return x.assignedToUserId !== assignmentInfo.memberId;
						} else {
							// filter role
							return x.assignedToRoleId !== assignmentInfo.memberId;
						}
					});

					assignment.assignmentSumary = filterSumary;
				}

				return newState;
			}

			return state;
		}
		case types.GET_MANAGE_ASSIGNMENTS_BYID: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				// Add response object into state
				let newState = _.cloneDeep(state);
				if (action.response) {
					if (action.response.find((f) => f.id !== unassignedId)) {
						let index = action.response.length > 1 ? 1 : 0;
						if (action.response[index]) {
							let assignmentIndex = newState.findIndex((i) => i.id === action.response[index].id);
							action.response
								.find((f) => f.id !== unassignedId)
								.assignmentSumary.map((x) => {
									if (x.assignedToRoleId > 0) {
										if (
											newState[assignmentIndex].assignmentSumary[
												newState[assignmentIndex].assignmentSumary.findIndex(
													(f) => f.assignedToRoleId === x.assignedToRoleId
												)
											]
										) {
											newState[assignmentIndex].assignmentSumary[
												newState[assignmentIndex].assignmentSumary.findIndex(
													(f) => f.assignedToRoleId === x.assignedToRoleId
												)
											] = x;
										}
									} else if (isNaN(x.assignedToUserId)) {
										if (
											newState[assignmentIndex].assignmentSumary[
												newState[assignmentIndex].assignmentSumary.findIndex(
													(f) => f.assignedToUserId === x.assignedToUserId
												)
											]
										) {
											newState[assignmentIndex].assignmentSumary[
												newState[assignmentIndex].assignmentSumary.findIndex(
													(f) => f.assignedToUserId === x.assignedToUserId
												)
											] = x;
										}
									}
								});
						}

						// find and replace the unassigned object
						if (newState[newState.findIndex((i) => i.id === unassignedId)]) {
							if (action.response.find((i) => i.id === unassignedId) != undefined) {
								newState[newState.findIndex((i) => i.id === unassignedId)] = action.response.find(
									(i) => i.id === unassignedId
								);
							} else {
								const index = newState.findIndex((i) => i.id === unassignedId);
								if (index > -1) {
									// removing unassgned object when all tasks are assigned
									newState.splice(index, 1);
								}
							}
						} else {
							if (action.response.find((i) => i.id === unassignedId) != undefined) {
								newState[newState.length] = action.response.find((i) => i.id === unassignedId);
							}
						}
					} else if (action.response.find((f) => f.id === unassignedId)) {
						if (newState[newState.findIndex((i) => i.id === unassignedId)]) {
							newState[newState.findIndex((i) => i.id === unassignedId)] = action.response.find(
								(i) => i.id === unassignedId
							);
						} else {
							newState[newState.length] = action.response.find((i) => i.id === unassignedId);
						}
					}
				}

				return newState;
			}
			return [];
		}
		case types.TEAM_MEMBER_ADDED: {
			if (action.meta.data) {
				let newState = _.cloneDeep(state);
				let filteredData = newState.filter((item) => item.id == action.meta.assignmentId);
				// adding new team member
				filteredData[0].assignmentSumary.push(action.meta.data);
				return newState;
			}
		}
		case types.BULK_DELETE_MEMBER_TASK_ASSIGNMENTS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.NoContent) {
				let newState = _.cloneDeep(state);

				return newState;
			}

			return state;
		}
		case types.REPLACE_MEMBER_TASK_ASSIGNMENT: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.NoContent) {
				let newState = _.cloneDeep(state);

				return newState;
			}

			return state;
		}
		case types.GET_ASSIGNMENTS_BY_ASSIGNMENT_ID: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				// Add response object into state
				let newState = _.cloneDeep(state);

				if (action.response) {
					if (action.response.find((f) => f.id !== unassignedId)) {
						// find and replace the unassigned object
						newState[newState.findIndex((i) => i.id === unassignedId)] = action.response.find(
							(i) => i.id === unassignedId
						);

						// find and replace the assigned object
						newState[
							newState.findIndex(
								(i) => i.id !== unassignedId && i.id === action.response.find((f) => f.id !== unassignedId).id
							)
						] = action.response.find((i) => i.id !== unassignedId);
					}
				}

				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}
